var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"auto !important"},attrs:{"id":"dnw-page"}},[_c('div',{staticStyle:{"height":"auto !important"},attrs:{"id":"dnw-main"}},[_c('center',{staticStyle:{"height":"auto !important"}},[_c('div',{staticClass:"dnw-sheet",staticStyle:{"height":"auto !important"}},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }